import type { AssetWorkflowOptions } from '../../types';

export const editTagWorkflow: AssetWorkflowOptions = {
  workflowKey: 'editTagWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'tags',
  workflowIndex: 1,
  workflowName: 'Edit Tag Workflow',
  workflowDescription: 'Edit a tag',
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Tag ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this tag',
        description: 'This is optional but will allow you to more easily reference this tag in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'tagName',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter the tag name',
        description: 'Enter the name of this tag. This should probably be the same as the tag value',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'tagDescription',
      workflowStepNavigationName: 'Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 4,
        prompt: 'Enter a description (optional):',
        description: '',
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Edit Tag Summary',
        description: 'The tag will be update.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
